import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VAT_DEDUCTION_TYPE = {
  '50': '50',
  '100': '100',
  CANT_DEDUCT: 'cant_deduct',
  IDK: 'does_not_know',
} as const;

export const VAT_DEDUCTION_TYPE_NAME = 'vat_deduction_type';
export const VAT_DEDUCTION_TYPE_NAME_COMPLEMENTARY =
  'vat_deduction_type_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioVATDeductionPercentage: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VAT_DEDUCTION_TYPE_NAME_COMPLEMENTARY
      : VAT_DEDUCTION_TYPE_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Wskaż procent odliczenia VAT')}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-vat-deduction-percentage"
            >
              <RadioItem
                value={VAT_DEDUCTION_TYPE['50']}
                label={i18n.t('50%')}
                data-testid="radio-item-vat-deduction-percentage-50"
              />
              <RadioItem
                value={VAT_DEDUCTION_TYPE['100']}
                label={i18n.t('100%')}
                data-testid="radio-item-vat-deduction-percentage-100"
              />
              <RadioItem
                value={VAT_DEDUCTION_TYPE.CANT_DEDUCT}
                label={i18n.t('Nie mogłem odliczyć VAT')}
                data-testid="radio-item-vat-deduction-percentage-cant-deduct"
              />
              <RadioItem
                value={VAT_DEDUCTION_TYPE.IDK}
                label={i18n.t('Nie wiem, zapytam księgową')}
                data-testid="radio-item-vat-deduction-percentage-idk"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
